import { Paper, PaperProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

type PageContentProps = {
  children: ReactNode;
} & PaperProps;

const PageContent: FC<PageContentProps> = ({
  children,
  p = "md",
  radius = 4,
  shadow = "xs",
  withBorder = true,
  ...others
}) => (
  <Paper p={p} radius={radius} shadow={shadow} withBorder={withBorder} {...others}>
    {children}
  </Paper>
);

export default PageContent;
